import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
// Cloud React components
import { Grid } from '@mui/material';
import { Button, Input, Form, Checkbox } from 'Components';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { NotificationManager } from 'Components/Notifications';
import IconPicker from 'Modules/.common/components/IconPicker';
// import TagPicker from 'Modules/.common/components/TagPicker';
import Tabs, { TabContainer } from 'Components/Tabs';
import TagsManage from 'Modules/.common/components/TagsManage';
import { createEditSearchDynamicForms } from './redux/slice';
//Hooks
import './styles.scss';

//actions
import {
    clearRedux,
    accountTagsOpenCreateEdit,
    accountTagsSaveTag,
    accountTagsGetTag,
    accountTagsGetEntities,
    catalogLoad
} from 'Redux/actions';
import { validateTagPermissions } from '../..';

const CreateEditAccountTag = (props) => {
    const dispatch = useDispatch();
    const { callback } = props;
    const { messages } = useIntl();

    const editCreateAccountTag = useRef();

    const users = useSelector(state => state.createEditTagRedux.users);
    const landmarks = useSelector(state => state.createEditTagRedux.landmarks);
    const drivers = useSelector(state => state.createEditTagRedux.drivers);
    const geofences = useSelector(state => state.createEditTagRedux.geofences);
    const units = useSelector(state => state.createEditTagRedux.units);
    const assets = useSelector(state => state.createEditTagRedux.assets);
    const dynamicForms = useSelector(state => state.createEditTagRedux.dynamicForms);
    const response = useSelector(state => state.createEditTagRedux.response);
    const loadingCreateEdit = useSelector(state => state.createEditTagRedux.loadingCreateEdit);
    const loadingTag = useSelector(state => state.createEditTagRedux.loadingTag);
    const id = useSelector(state => state.createEditTagRedux.id);
    const tag = useSelector(state => state.createEditTagRedux.tag);
    const open = useSelector(state => state.createEditTagRedux.openCreateEdit);
    const loadingEntities = useSelector(state => state.createEditTagRedux.loadingEntities);
    const disabledEntities = useSelector(state => state.createEditTagRedux.disabledEntities);
    const user = useSelector((state) => state.securityRedux.user);

    const allEntities = useMemo(
        () => [
            { id: "All", label: messages['all'] },
            { id: "Tag", label: messages["asset_tab_tags"] },
            { id: "Unit", label: messages['unit_value'] },
            { id: "Driver", label: messages["drivers"] },
            { id: "Landmark", label: messages['landmarks'] },
            { id: "Geofence", label: messages['geofences'] },
            { id: "Asset", label: messages['asset_tab_asset'] },
            { id: "User", label: messages['menu_users'] },
            { id: "Form", label: messages['menu_dynamic_forms'] }
        ],
        [messages]
    );

    const [formData, setFormData] = useState({});
    const [errorMessage, setErrorMessage] = useState(null);

    useEffect(() => {
        dispatch(catalogLoad(['subusers','forms']));
        dispatch(createEditSearchDynamicForms({ limit: 1000, offset: 0, openSearch: '', status: 'active' }));
        return () => {
            dispatch(clearRedux("ACCOUNT_TAGS_CREATE_EDIT"));
            setFormData({});
        }
    }, []);

    useEffect(() => {
        if (id && open) {
            dispatch(accountTagsGetTag(id));
        }
    }, [id, open]);

    useEffect(() => {
        if (units && open) {
            setFormData({ 
                ...formData, 
                units: units.map(unit => ({ ...unit, id: parseInt(unit.id) })),
                unitIds: units.map(unit => parseInt(unit.id))
            });
        }
    }, [units, open]);

    useEffect(() => {
        if (assets && open) {
            setFormData({ 
                ...formData, 
                assets: assets.map(asset => ({ ...asset, id: parseInt(asset.id) })),
                assetIds: assets.map(asset => parseInt(asset.id))
            });
        }
    }, [assets, open]);

    useEffect(() => {
        if (drivers && open) {
            setFormData({ 
                ...formData, 
                drivers: drivers.map(driver => ({ 
                    ...driver, 
                    driverId: parseInt(driver.driverId || driver.id),
                    name: driver.name || driver.label
                })),
                driverIds: drivers.map(driver => parseInt(driver.driverId || driver.id))
            });
        }
    }, [drivers, open]);

    useEffect(() => {
        if (landmarks && open) {
            setFormData({ 
                ...formData, 
                landmarks: landmarks.map(landmark => ({ ...landmark, id: parseInt(landmark.id) })),
                landmarkIds: landmarks.map(landmark => parseInt(landmark.id))
            });
        }
    }, [landmarks, open]);

    useEffect(() => {
        if (geofences && open) {
            setFormData({ 
                ...formData, 
                geofences: geofences.map(geofence => ({ ...geofence, id: parseInt(geofence.id) })),
                geofenceIds: geofences.map(geofence => parseInt(geofence.id))
            });
        }
    }, [geofences, open]);

    useEffect(() => {
        if (users && open) {
            setFormData({ 
                ...formData, 
                users: users.map(user => ({ ...user, id: parseInt(user.id) })),
                userIds: users.map(user => parseInt(user.id))
            });
        }
    }, [users, open]);

    useEffect(() => {
        if (dynamicForms && open) {
            setFormData({ 
                ...formData, 
                dynamicForms: dynamicForms.map(form => ({ ...form, id: parseInt(form.id) })),
                dynamicFormIds: dynamicForms.map(form => parseInt(form.id))
            });
        }
    }, [dynamicForms, open]);

    useEffect(() => {
        if (tag && open) {
            if (tag.error) {
                NotificationManager.error(
                    messages['errorMessage'],
                    messages['error'],
                    3000,
                    null,
                    null,
                    'warning',
                );
                handleClose();
            } else {
                setFormData({ ...tag, tag: tag?.parent, nestUnder: tag.parentId ? true : false });
            }
        }
    }, [tag, open]);

    useEffect(() => {
        if (response && open) {
            if (response.error) {
                /*
                NotificationManager.error(
                    messages['errorMessage'],
                    messages['error'],
                    3000,
                    null,
                    null,
                    'warning',
                );
                */

                dispatch(clearRedux("ACCOUNT_TAGS_CREATE_EDIT", { loadingCreateEdit: false, response: null }));
            } else {
                NotificationManager.success(
                    messages['accountTagsCreateEditTag_success'],
                    messages['success'],
                    3000,
                    null,
                    null,
                    'success',
                );
                if (callback) callback(formData.name);
                handleClose();
            }
        }
    }, [response, open]);

    const handleClose = useCallback(() => {
        dispatch(accountTagsOpenCreateEdit(false));
        dispatch(clearRedux("ACCOUNT_TAGS_CREATE_EDIT"));
        setFormData({});
    });

    const onSubmit = () => {
        setErrorMessage(null);
        let newFormData = {
            ...formData,
            color: formData?.color || '8677D9',
            unitIds: formData.unitModified ? formData?.unitIds || null : null,
            driverIds: formData.driverModified ? formData?.driverIds || null : null,
            landmarkIds: formData.landmarkModified ? formData?.landmarkIds || null : null,
            userIds: formData.userModified ? formData?.userIds || null : null,
            assetIds: formData.assetModified ? formData?.assetIds || null : null,
            dynamicFormIds: formData.dynamicFormModified ? formData?.dynamicFormIds || null : null,
            geofenceIds: formData.geofenceModified ? formData?.geofenceIds || null : null,
        };

        if (newFormData?.tag) {
            delete newFormData?.tag;
        } else {
            newFormData.parentId = null;
        }

        if (formData.nestUnder && !newFormData.parentId) {
            setErrorMessage(messages['required_field']);
            return;
        }

        NotificationManager.info(
            messages['accountTagsCreateEditTag_saving'],
            '',
            2000,
            null,
            null,
            'info',
        );

        dispatch(accountTagsSaveTag(newFormData));
    };

    const title = tag ? `${messages['accountTagsCreateEditTag_editTitle']} '${tag?.label}'` : `${messages['accountTagsCreateEditTag_createTitle']}`;

    const tabs = [
        {
            permission: "",
            permissionSubUser: [13],
            icon: "directions_car",
            label: messages['accountTagsCreateEditTag_unit'],
            entity: "Unit",
            value: formData?.units || [],
            onChange: (newUnits) => {
                setFormData({ 
                    ...formData, 
                    units: newUnits.map(unit => ({ ...unit, id: parseInt(unit.id) })),
                    unitIds: newUnits.map(unit => parseInt(unit.id)),
                    unitModified: true
                });
            },
        },
        {
            permission: "",
            icon: "settings",
            label: messages['accountTagsCreateEditTag_assets'],
            entity: "Asset",
            value: formData?.assets || [],
            onChange: (newAssets) => {
                setFormData({ 
                    ...formData, 
                    assets: newAssets.map(asset => ({ ...asset, id: parseInt(asset.id) })),
                    assetIds: newAssets.map(asset => parseInt(asset.id)),
                    assetModified: true
                });
            },
        },
        {
            permission: "driver",
            permissionSubUser: [17],
            icon: "person",
            label: messages['accountTagsCreateEditTag_drivers'],
            entity: "Driver",
            value: formData?.drivers || [],
            onChange: (newDrivers) => {
                setFormData({ 
                    ...formData, 
                    drivers: newDrivers.map(driver => ({ 
                        ...driver, 
                        driverId: parseInt(driver.driverId || driver.id),
                        name: driver.name || driver.label
                    })),
                    driverIds: newDrivers.map(driver => parseInt(driver.driverId || driver.id)),
                    driverModified: true
                });
            },
        },
        {
            permission: "",
            permissionSubUser: [3],
            icon: "flag",
            label: messages['accountTagsCreateEditTag_landmarks'],
            entity: "Landmark",
            value: formData?.landmarks || [],
            onChange: (newLandmarks) => {
                setFormData({ 
                    ...formData, 
                    landmarks: newLandmarks.map(landmark => ({ ...landmark, id: parseInt(landmark.id) })),
                    landmarkIds: newLandmarks.map(landmark => parseInt(landmark.id)),
                    landmarkModified: true
                });
            },
        },
        {
            permission: "",
            permissionSubUser: [1],
            icon: "pentagon",
            label: messages['accountTagsCreateEditTag_geofences'],
            entity: "Geofence",
            value: formData?.geofences || [],
            onChange: (newGeofences) => {
                setFormData({ 
                    ...formData, 
                    geofences: newGeofences.map(geofence => ({ ...geofence, id: parseInt(geofence.id) })),
                    geofenceIds: newGeofences.map(geofence => parseInt(geofence.id)),
                    geofenceModified: true
                });
            },
        },
        {
            permission: "",
            permissionSubUser: [31],
            icon: "supervisor_account",
            label: messages['accountTagsCreateEditTag_users'],
            entity: "User",
            value: formData?.users || [],
            onChange: (newUsers) => {
                setFormData({ 
                    ...formData, 
                    users: newUsers.map(user => ({ ...user, id: parseInt(user.id) })),
                    userIds: newUsers.map(user => parseInt(user.id)),
                    userModified: true
                });
            },
        },
        {
            permission: "dappfrm",
            permissionSubUser: [246],
            icon: "ballot",
            label: messages['accountTagsCreateEditTag_dynamicForms'],
            entity: "Form",
            value: formData?.dynamicForms || [],
            onChange: (newDynamicForms) => {
                setFormData({ 
                    ...formData, 
                    dynamicForms: newDynamicForms.map(form => ({ ...form, id: parseInt(form.id) })),
                    dynamicFormIds: newDynamicForms.map(form => parseInt(form.id)),
                    dynamicFormModified: true
                });
            },
        },
    ];

    const tabsWithPermissions = validateTagPermissions(user, tabs, true)

    return (
        <Modal
            title={title}
            open={open}
            loading={loadingTag}
            position="right"
            size="small"
            style={{ overflow: 'hidden' }}
            className="overflow-hidden"
            handleClose={handleClose}
        >
            <ModalBody
                style={{
                    overflow: 'hidden',
                    marginBottom: 0
                }}
            >
                <div
                    style={{
                        padding: "0px 24px 24px 24px",
                        height: "calc(100vh - 225px)"
                    }}
                >
                    <Tabs
                        tab={0}
                        type="icon-indicator"
                        border
                        onChange={(newTab) => {
                            if (newTab > 0 && id) {
                                let entityName = tabsWithPermissions[newTab - 1]?.entity;
                                if (entityName) {
                                    dispatch(accountTagsGetEntities({
                                        parentTagId: id,
                                        entityName: entityName,
                                    }));
                                }
                            }
                        }}
                    >
                        <TabContainer
                            iconIndicator="local_offer"
                            label={messages['accountTagsCreateEditTag_tag']}
                            index={0}
                            style={{ paddingLeft: 0, paddingRight: 0 }}
                            disabled={loadingEntities}
                        >
                            <Form ref={editCreateAccountTag} onValidSubmit={onSubmit}>
                                <div style={{ width: '100%' }}>
                                    <label className='input-normal-label'>
                                        {messages['accountTagsCreateEditTag_color']} <span className="text-danger"> *</span>
                                    </label>
                                </div>

                                <Grid
                                    container
                                    wrap="nowrap"
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="flex-start"
                                    style={{ width: '100%' }}
                                >
                                    <Grid item style={{ height: 0 }}>
                                        <div className="form-item">
                                            <IconPicker
                                                color={formData.color}
                                                options={["color"]}
                                                onChange={(color) => setFormData({ ...formData, color: color })}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid zeroMinWidth item xs>
                                        <Input
                                            id="label"
                                            type="text"
                                            placeholder={messages['accountTagsCreateEditTag_label']}
                                            value={formData.label || ""}
                                            onChange={(value) => setFormData({ ...formData, label: value })}
                                            required
                                            requiredMessage={messages['required_field']}
                                            maxLength={50}
                                        />
                                    </Grid>
                                </Grid>

                                <div style={{ width: '100%', marginTop: 10 }}>
                                    <Checkbox
                                        id="nestUnder"
                                        label={messages['accountTagsCreateEditTag_nestUnder']}
                                        value={formData.nestUnder}
                                        onChange={(value) => {
                                            setFormData({ ...formData, nestUnder: value, parentId: null, tag: null });
                                            setErrorMessage(null);
                                        }}
                                        size="small"
                                    />
                                </div>

                                {
                                    formData.nestUnder &&
                                    <div style={{ width: '100%', marginTop: 10 }}>
                                        {
                                            errorMessage &&
                                            <small className='text-danger'>{errorMessage}</small>
                                        }
                                        <TagsManage
                                            isVisiblePills={true}
                                            onlyTags={true}
                                            mode="list"
                                            height={500}
                                            value={formData?.tag}
                                            multiple={false}
                                            onChange={(value) => {
                                                if (tag && tag.id === value[0]?.id) {
                                                    setErrorMessage(messages['accountTagsCreateEditTag_errorParentTag']);
                                                    return;
                                                }

                                                setErrorMessage(null);
                                                setFormData({ ...formData, tag: value, parentId: value[0]?.id });
                                            }}
                                        />
                                    </div>
                                }
                            </Form>
                        </TabContainer>
                        {tabsWithPermissions.map((tab, idx) => {
                            const varEntitySelected = allEntities.find(e => e.id == tab.entity);
                            const entities = [];
                            //entities.push(allEntities.find(t => t.id === 'Tag'));
                            entities.push(varEntitySelected);
                            
                            return (
                                
                                <TabContainer
                                    key={idx}
                                    iconIndicator={tab.icon}
                                    label={tab.label}
                                    index={tab.index}
                                    style={{ paddingLeft: 0, paddingRight: 0 }}
                                    disabled={loadingEntities || disabledEntities}
                                    >
                                        <div className="create-edit-events-tab-tags" style={{ width: '100%', overflow: "auto", marginTop: 5 }}>
                                            <TagsManage
                                                entities={entities}
                                                onChange={tab.onChange}
                                                hideTagsWithoutEntities={true}
                                                mode="list"
                                                onlyCheckEntities={true}
                                                showUntagged={false}
                                                height={550}
                                                value={tab.value}
                                                entitySelected={varEntitySelected}
                                            />
                                        </div>
                                    </TabContainer>

                                )
                            }
                        )}
                    </Tabs>
                </div>
            </ModalBody>

            <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }}>
                <Button
                    disabled={loadingCreateEdit}
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    disabled={loadingCreateEdit}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        editCreateAccountTag.current.submit();
                    }}
                    className="btn-blue"
                >
                    {tag ? messages['save'] : messages['create']}
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default CreateEditAccountTag;